import React from "react";

import { SkillsManagementHeader } from "./header";
import css from "./skills_management.module.scss";
import { SkillsManagementTable } from "./table/skills_management_table";

export const SkillsManagement = () => (
  <div className={css.mainContainer}>
    <SkillsManagementHeader />
    <SkillsManagementTable />
  </div>
);
